var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30360_4594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.25 13.2974H2.25C1.42 13.2974 0.75 12.6274 0.75 11.7974V2.79736C0.75 1.96736 1.42 1.29736 2.25 1.29736H15.25C16.08 1.29736 16.75 1.96736 16.75 2.79736V11.7974C16.75 12.6274 16.08 13.2974 15.25 13.2974ZM2.25 2.29736C1.97 2.29736 1.75 2.51736 1.75 2.79736V11.7974C1.75 12.0774 1.97 12.2974 2.25 12.2974H15.25C15.53 12.2974 15.75 12.0774 15.75 11.7974V2.79736C15.75 2.51736 15.53 2.29736 15.25 2.29736H2.25Z",
    fill: "#67A3CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74943 9.25748C8.04944 9.25748 7.40943 8.97748 6.92943 8.46748L1.67944 2.88748C1.48944 2.68748 1.49944 2.36748 1.69944 2.17748C1.89944 1.98748 2.21943 1.99748 2.40943 2.19748L7.65943 7.77748C8.22943 8.38748 9.26944 8.38748 9.83944 7.77748L15.0894 2.20748C15.2794 2.00748 15.5994 1.99748 15.7994 2.18748C15.9994 2.37748 16.0094 2.69748 15.8194 2.89748L10.5694 8.47748C10.0894 8.98748 9.44943 9.26748 8.74943 9.26748V9.25748Z",
    fill: "#67A3CE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30360_4594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "white",
    transform: "translate(0.75 0.297363)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.c2743ce50328b917de00a999b31f07d8.svg";
export { ForwardRef as ReactComponent };